
import { axiosApiInstance } from 'Store';
import {
    ApiLocationItem,
    ApiLocationSearchItem,
    LocationItem,
    SearchLocationResultType
} from 'utils/types/V2Locations';

const mapApiLocationToLocationItem = (apiItem: ApiLocationItem): LocationItem => ({
    id: apiItem.id,
    label: apiItem.name,
    children: apiItem.children.map(mapApiLocationToLocationItem)
});

const mapApiSearchLocationToLocationItem = (apiItem: ApiLocationSearchItem): SearchLocationResultType => ({
    id: apiItem.id,
    label: apiItem.name,
    children: []
});

const getVoivodeships = async (): Promise<LocationItem[]> => {
    return axiosApiInstance
        .get<ApiLocationItem[]>('/location/v2/voivodeships?extendedMode=true')
        .then((resp) => {
            if (resp.data) {
                return resp.data.map(mapApiLocationToLocationItem);
            }

            return [];
        })
        .catch(() => {
            return [];
        });
};

const getVoivodeshipCities = async (id: number): Promise<LocationItem[]> => {
    return axiosApiInstance
        .get<ApiLocationItem[]>(`/location/v2/voivodeship-cities?parent=${id}&extendedMode=true`)
        .then((resp) => {
            if (resp.data) {
                return resp.data.map(mapApiLocationToLocationItem);
            }

            return [];
        })
        .catch(() => {
            return [];
        });
};

const getLocationsFromSearch = async (search: string): Promise<LocationItem[]> => {
    return axiosApiInstance
        .get<ApiLocationSearchItem[]>(`/location/v2/match?name=${search}&extendedMode=true`)
        .then((resp) => {
            if (resp.data) {
                return resp.data.map(mapApiSearchLocationToLocationItem);
            }

            return [];
        })
        .catch(() => {
            return [];
        });
};

export const v2filtersApiRequests = {
    getVoivodeships,
    getVoivodeshipCities,
    getLocationsFromSearch
};
